import request from '@utils/fetch'

// 查询当前主题 所有上传资料 列表
export function selectThemeDataDetail(data) {
  return request({
    url: '/curriculumManage/selectThemeDataDetail',
    method: 'post',
    data
  })
}

// 上传 自然拼读 素材 资料接口
export function addNaturalSpelling(data) {
  return request({
    url: '/themeManage/addNaturalSpelling',
    method: 'post',
    data
  })
}

// 上传 单词 素材 资料接口
export function addWord(data) {
  return request({
    url: '/themeManage/addWord',
    method: 'post',
    data
  })
}

// 上传 高频词 素材 资料接口
export function addHighFrequency(data) {
  return request({
    url: '/themeManage/addHighFrequency',
    method: 'post',
    data
  })
}

// 上传 句型 素材 资料接口
export function addSentencePattern(data) {
  return request({
    url: '/themeManage/addSentencePattern',
    method: 'post',
    data
  })
}

// 上传 句型组 素材 资料接口
export function addSentencePatternGroup(data) {
  return request({
    url: '/themeManage/addSentencePatternGroup',
    method: 'post',
    data
  })
}

// 上传 自定义 资料接口 （游戏配置里面）
export function addCustomMeansReq(data) {
  return request({
    url: '/themeManage/addCustomMeansReq',
    method: 'post',
    data
  })
}

// 上传 字母 与 视频 接口
export function addBasicMeans(data) {
  return request({
    url: '/themeManage/addBasicMeans',
    method: 'post',
    data
  })
}

// 修改视频和单词的接口
export function editBasicMeans(data) {
  console.log(data)
  return request({
    url: '/themeManage/updateBasicMeans',
    method: 'post',
    data
  })
}
// 查询句型组详情接口
export function searchDetailBysentenceGroup(data) {
  return request({
    url: '/themeManage/editGroupBasicMeans',
    method: 'post',
    data
  })
}
// 查询高频词和自然拼读的接口
export function searchDetailByNatural(data) {
  return request({
    url: '/themeManage/editTreeBasicMeans',
    method: 'post',
    data
  })
}

export function searchDetailByBasic(data) {
  return request({
    url: '/themeManage/editBasicMeans',
    method: 'post',
    data
  })
}
